import { getText } from '@storebrand-digital/fms-translations';
import {
  CarDetails,
  InsuranceDetailsView,
  isAlis,
  MotorcycleDetails,
} from 'Api/insurance';
import {
  getBonus,
  getDiscount,
  getInsuranceValidity,
  getPriceInsuranceDetails,
} from 'Components/InsuranceDetailsSections/helpers/insuranceDetailsSections.mapToInsuranceDetailsView.helpers';
import {
  alisPolicyNumberText,
  DETAILED_PRIMARY_DISCOUNT_LABEL_FMS_KEY,
  DETAILED_PRIMARY_INSURANCE_VALIDITY_LABEL_FMS_KEY,
  policyNumberText,
} from 'Components/InsuranceDetailsSections/insuranceDetailsSections.constants';
import { TfaRegistry } from 'Components/InsuranceDetailsSections/insuranceDetailsSections.types';
import { getInsuranceProductName } from 'Utils/products.utils';
import { getTfaPrice } from './mapBaseVehicleValuesToInsuranceDetailsView';

export function mapBaseCarMotorcycleValuesToInsuranceDetailsView(
  insurance: CarDetails | MotorcycleDetails,
  tfaRegistry: TfaRegistry[] | undefined,
  cwpDetailsToggle: boolean,
): Omit<InsuranceDetailsView, 'secondary'> {
  return {
    ...getCarRentalType(insurance),
    insuranceProduct: insurance.insuranceProduct,
    agreementProduct: insurance.agreementProduct,
    policyNumber: insurance.policyNumber,
    riskList: insurance.riskList,
    productName: getInsuranceProductName(insurance.productName),
    organizationPillar: insurance.organizationPillar,
    canChange: insurance.canChange,
    coverage: insurance.coverage,
    isInRenewal: insurance.isInRenewal,
    insuranceStatus: insurance.insuranceStatus,
    title: [
      `${insurance.brand} ${insurance.model} ${insurance.modelYear}`,
      insurance.licensePlateNumber,
    ],
    isDeregistered: insurance.isDeregistered,
    primary: [
      {
        label: getText(DETAILED_PRIMARY_INSURANCE_VALIDITY_LABEL_FMS_KEY),
        value: getInsuranceValidity(insurance),
      },
      {
        label: getText(
          isAlis(insurance.systemName)
            ? alisPolicyNumberText
            : policyNumberText,
        ),
        value: insurance.policyNumber,
      },
      {
        label: getText('detailed.primary.bonus.label'),
        value: getBonus(insurance),
      },
      {
        label: getText('detailed.primary.priceVehicle.label'),
        value: getPriceInsuranceDetails(
          insurance,
          'detailed.primary.priceVehicle.value',
          cwpDetailsToggle,
        ),
      },
      {
        label: getText('detailed.primary.tfa.label'),
        value: getTfaPrice(
          insurance.tfaCode,
          insurance.outerIssueDate,
          insurance.agreementProduct,
          insurance.isDeregistered,
          tfaRegistry,
        ),
      },
      {
        label: getText(DETAILED_PRIMARY_DISCOUNT_LABEL_FMS_KEY),
        value: getDiscount(insurance.agreementProduct),
      },
    ],
  };
}

const getCarRentalType = (insurance: CarDetails | MotorcycleDetails) => {
  const isRentalTypeInInsurance = 'rentalType' in insurance;
  if (isRentalTypeInInsurance) {
    return { rentalType: insurance.rentalType };
  }
  return undefined;
};
